<template>
  <div>
    <div
      class="
        uk-position-fixed
        background
        uk-background-muted uk-height-1-1 uk-width-1-1
      "
    ></div>
    <top-menu-bar
      :title="headTitle"
      :show-menu="showMenu"
      :show-right-menu="showRightMenu"
      :show-back-button="showBackButton"
      :back-route-name="backRouteName"
    >
      <template v-slot:navbar-left>
        <slot name="navbar-left"></slot>
      </template>

      <template v-slot:navbar-center>
        <slot name="navbar-center"></slot>
      </template>

      <template v-slot:navbar-right>
        <slot name="navbar-right"></slot>
      </template>
    </top-menu-bar>

    <main
      :class="{ 'uk-margin-large-bottom': showFooterMenu || $slots.footer }"
      class="uk-section uk-section-xsmall"
    >
      <div class="uk-container" :class="mainContainerClass">
        <slot />
      </div>
    </main>
    <footer
      class="
        uk-flex uk-flex-bottom uk-flex-center uk-margin-small-bottom
        custom-box-shadow-top
      "
    >
      <slot name="footer"></slot>
    </footer>
    <div class=""></div>
  </div>
</template>

<script lang="ts">
import TopMenuBar from '../components/TopMenuBar.vue';

export default {
  name: 'MainLayout',
  props: {
    headTitle: String,
    showMenu: Boolean,
    showBackButton: Boolean,
    backRouteName: String,
    showRightMenu: Boolean,
    showFooterMenu: Boolean,
    mainContainerClass: { type: String, default: 'uk-container-xsmall' },
  },
  components: { TopMenuBar },
};
</script>

<style lang="scss" scoped>
.background {
  z-index: -1;
}
</style>
